/**
 * Painel flutuante: desloca mains dos cards (translateY).
 * Ativo com ?gm-nudge=1 na URL.
 */
(function () {
  'use strict';

  try {
    if (!/([?&])gm-nudge=1(?:&|$)/.test(location.search)) return;
  } catch (e) {
    return;
  }

  var MASTER_W = 1650;
  var MASTER_H = 2200;
  var STYLE_ID = 'gm-card-nudge-style';
  var UI_ID = 'gm-card-nudge-ui';
  var state = { shift: 0 };

  function injectStyle() {
    var el = document.getElementById(STYLE_ID);
    if (!el) {
      el = document.createElement('style');
      el.id = STYLE_ID;
      document.head.appendChild(el);
    }
    el.textContent =
      '.gm-card__media{background:#f6f6f6!important;}' +
      '.gm-card__img{' +
      'transform:translateY(var(--gm-nudge-y,0px))!important;' +
      'object-position:center calc(50% + var(--gm-nudge-y,0px))!important;' +
      '}' +
      '.gm-card__media:hover .gm-card__img--active{' +
      'transform:translateY(var(--gm-nudge-y,0px)) scale(var(--gm-hover-scale,1.02))!important;' +
      '}' +
      '#' +
      UI_ID +
      '{' +
      'position:fixed;right:16px;bottom:16px;z-index:2147483646;' +
      'display:flex;flex-direction:column;gap:8px;min-width:168px;' +
      'padding:12px;border:1px solid #ddd;background:rgba(255,255,255,.96);' +
      'box-shadow:0 8px 24px rgba(0,0,0,.18);font:600 12px/1.2 system-ui,sans-serif;' +
      'color:#111;user-select:none;' +
      '}' +
      '#' +
      UI_ID +
      ' .gm-nudge-title{font-size:11px;letter-spacing:.06em;text-transform:uppercase;color:#666;}' +
      '#' +
      UI_ID +
      ' .gm-nudge-readout{font:700 13px/1.3 ui-monospace,Consolas,monospace;color:#111;}' +
      '#' +
      UI_ID +
      ' .gm-nudge-row{display:flex;gap:6px;}' +
      '#' +
      UI_ID +
      ' button{' +
      'flex:1;min-height:36px;padding:8px 6px;border:1px solid #111;background:#fff;' +
      'color:#111;font:700 14px/1 system-ui,sans-serif;cursor:pointer;' +
      '}' +
      '#' +
      UI_ID +
      ' button:hover{background:#111;color:#fff;}' +
      '#' +
      UI_ID +
      ' button:focus-visible{outline:2px solid #1bc875;outline-offset:2px;}' +
      '#' +
      UI_ID +
      ' .gm-nudge-yarn{font-size:11px;letter-spacing:.04em;text-transform:uppercase;}';
  }

  function sampleMedia() {
    var media = document.querySelector('.gm-card__media');
    if (!media) return null;
    var r = media.getBoundingClientRect();
    return { w: Math.round(r.width), h: Math.round(r.height) };
  }

  function coverScale(dispW, dispH) {
    return Math.max(dispW / MASTER_W, dispH / MASTER_H);
  }

  function updateUi() {
    var ui = document.getElementById(UI_ID);
    if (!ui) return;
    var readout = ui.querySelector('[data-gm-nudge-readout]');
    if (!readout) return;
    var last = state.last;
    if (!last) {
      readout.textContent = 'shift ' + state.shift + 'px';
      return;
    }
    readout.innerHTML =
      'tela <strong>' +
      last.displayShift +
      'px</strong> ↓<br>card ' +
      last.displayW +
      '×' +
      last.displayH +
      '<br>master <strong>' +
      last.masterShift +
      'px</strong>';
  }

  function apply() {
    injectStyle();
    ensureUi();
    document.documentElement.style.setProperty('--gm-nudge-y', state.shift + 'px');
    var sample = sampleMedia();
    if (!sample) {
      updateUi();
      return;
    }
    var scale = coverScale(sample.w, sample.h);
    var mShift = Math.round(state.shift / scale);
    state.last = {
      displayW: sample.w,
      displayH: sample.h,
      displayShift: state.shift,
      masterShift: mShift,
      scale: scale,
    };
    updateUi();
    console.log(
      '[gm-nudge] card ' +
        sample.w +
        '×' +
        sample.h +
        ' · tela ' +
        state.shift +
        'px ↓ · master ≈ ' +
        mShift +
        'px'
    );
  }

  function bump(delta) {
    state.shift = Math.max(0, state.shift + delta);
    apply();
  }

  function printYarn() {
    if (!state.last) apply();
    var last = state.last;
    if (!last || last.masterShift <= 0) {
      console.warn('[gm-nudge] Use ↓ antes de copiar.');
      return;
    }
    var cmd =
      'yarn mains:nudge --shift=' +
      last.masterShift +
      ' --dir="novas-imagens/produtos/novas imagens main" --out="novas-imagens/produtos/novas imagens main nudged"';
    console.log('[gm-nudge] ' + cmd);
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(cmd).catch(function () {});
    }
  }

  function ensureUi() {
    if (document.getElementById(UI_ID)) return;
    var ui = document.createElement('div');
    ui.id = UI_ID;
    ui.setAttribute('role', 'dialog');
    ui.setAttribute('aria-label', 'Ajuste posição main do card');
    ui.innerHTML =
      '<div class="gm-nudge-title">Nudge main</div>' +
      '<div class="gm-nudge-readout" data-gm-nudge-readout>shift 0px</div>' +
      '<div class="gm-nudge-row">' +
      '<button type="button" data-gm-nudge-down>↓</button>' +
      '<button type="button" data-gm-nudge-up>↑</button>' +
      '</div>' +
      '<div class="gm-nudge-row">' +
      '<button type="button" data-gm-nudge-down5>−5</button>' +
      '<button type="button" data-gm-nudge-up5>+5</button>' +
      '</div>' +
      '<div class="gm-nudge-row">' +
      '<button type="button" data-gm-nudge-zero>0</button>' +
      '<button type="button" class="gm-nudge-yarn" data-gm-nudge-yarn>Yarn</button>' +
      '</div>';
    ui.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t) return;
      e.preventDefault();
      e.stopPropagation();
      if (t.hasAttribute('data-gm-nudge-down')) bump(1);
      else if (t.hasAttribute('data-gm-nudge-up')) bump(-1);
      else if (t.hasAttribute('data-gm-nudge-down5')) bump(5);
      else if (t.hasAttribute('data-gm-nudge-up5')) bump(-5);
      else if (t.hasAttribute('data-gm-nudge-zero')) {
        state.shift = 0;
        apply();
      } else if (t.hasAttribute('data-gm-nudge-yarn')) printYarn();
    });
    document.body.appendChild(ui);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
